"use server";

import { AuthError } from "next-auth";
import { z } from "zod";

import { signIn, signOut } from "@/auth/auth";

// Auth.js v5 normaliza el identifier en `sendToken` con `.toLowerCase().trim()` antes de
// almacenar el `verification_tokens.identifier`. Aplicamos la misma normalización aquí
// para que el lookup en el callback coincida (la pantalla de código envía el email como
// hidden field al endpoint de Auth.js).
const emailSchema = z.object({
	email: z
		.string()
		.email()
		.transform((v) => v.toLowerCase().trim()),
});

/**
 * Inicia el flujo email-code: dispara `signIn("email", { email })`. Auth.js genera el
 * código (6 dígitos), lo hashea con sha256(code + AUTH_SECRET) y lo persiste, y lo
 * envía por Resend. El callback `signIn` (lib/auth.ts) deja pasar cualquier email
 * autenticado — la verificación de tenant es responsabilidad de la onboarding.
 */
export async function loginWithEmail(_prev, formData) {
	const parsed = emailSchema.safeParse(Object.fromEntries(formData));
	if (!parsed.success) {
		return { status: "error", message: "Email inválido." };
	}
	const { email } = parsed.data;

	try {
		await signIn("email", {
			email,
			redirectTo: "/dashboard",
			redirect: false,
		});
		return {
			status: "sent",
			email,
			message: "Te hemos enviado un código por email. Revisa tu bandeja.",
		};
	} catch (error) {
		if (error instanceof AuthError) {
			// Mensaje neutro para no filtrar señales sobre el email.
			return {
				status: "sent",
				email,
				message:
					"Te hemos enviado un código por email. Revisa tu bandeja.",
			};
		}
		throw error;
	}
}

export async function loginWithGoogle() {
	await signIn("google", { redirectTo: "/dashboard" });
}

export async function logout() {
	await signOut({ redirectTo: "/" });
}
